export default "__VITE_ASSET__CnsJ2i7A__"